// extracted by mini-css-extract-plugin
export var content = "ZPattern-module--content--268a4";
export var copy = "ZPattern-module--copy--9cc7b";
export var flip = "ZPattern-module--flip--aec0a";
export var image = "ZPattern-module--image--84060";
export var inView = "ZPattern-module--in-view--03615";
export var lilacDeep = "ZPattern-module--lilac-deep--2a456";
export var section = "ZPattern-module--section--5b6fe";
export var zPatternBlock = "ZPattern-module--z-pattern-block--0cf6f";